
import { Vue, Options } from "vue-class-component";
import Toaster from "../../helpers/Toaster";
import { useStore, ActionTypes } from "../../store";
import router from "../../router";
import CashierSession from "../../service/CashierSession";

@Options({
  components: {},
  title: "Cashier Session Logout",
})
export default class CashierSessionLogout extends Vue {
  private store;
  private toast;
  
  created() {
    this.toast = new Toaster();
    this.store = useStore();
  }

  mounted() {
    this.logoutCashier();
  }


  logoutCashier() {
    const cashierSession = new CashierSession();
    const store = useStore();

    cashierSession
      .logoutCashier()
      .then((res) => {
        if (res.status_id == 1) {
          this.toast.showInfo(res.msg);
          this.store.dispatch(ActionTypes.CASHIER_SESSION, "");
          router.push({ path: "/home/dashboard" });
        } else {          
          this.toast.handleResponse(res);
        }
      });

  }
}
